import { render, staticRenderFns } from "./AffectationGrille.vue?vue&type=template&id=ccc1b3aa&scoped=true"
import script from "./AffectationGrille.vue?vue&type=script&lang=js"
export * from "./AffectationGrille.vue?vue&type=script&lang=js"
import style0 from "./AffectationGrille.vue?vue&type=style&index=0&id=ccc1b3aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc1b3aa",
  null
  
)

export default component.exports